var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 35H33.7328V34.118H0V35Z",
    fill: "#A2A8AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5696 23.4775H14.8938L15.3029 9.94267L15.3979 6.80508L15.5085 3.13741L15.6034 -1.90735e-06H17.8602L17.9553 3.13741L18.0658 6.80508L18.1607 9.94267L18.5696 23.4775Z",
    fill: "#D2D9DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1605 9.94263H15.3027L15.3977 6.80503H18.0656L18.1605 9.94263Z",
    fill: "#E96666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9551 3.13733H15.5083L15.6032 -8.41618e-05H17.86L17.9551 3.13733Z",
    fill: "#E96666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8572 23.4775H16.7192V9.94267H18.1487L18.5042 21.7175H16.8572V23.4775ZM18.0534 6.80508H16.7192V3.13741H17.9429L18.0534 6.80508Z",
    fill: "#BFCACC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1487 9.94263H16.7192V6.80503H18.0534L18.1487 9.94263Z",
    fill: "#C83043"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9429 3.13733H16.7192V-8.41618e-05H17.8478L17.9429 3.13733Z",
    fill: "#C83043"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6854 25.6302H23.0098L23.4189 12.0955L23.5138 8.9577L23.6243 5.29021L23.7192 2.15271H25.9762L26.0713 5.29021L26.1817 8.9577L26.2766 12.0955L26.6854 25.6302Z",
    fill: "#D2D9DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2766 12.0956H23.4189L23.5138 8.95782H26.1817L26.2766 12.0956Z",
    fill: "#E96666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0712 5.29028H23.6243L23.7192 2.15278H25.9761L26.0712 5.29028Z",
    fill: "#E96666"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5215 20.6207H24.835V12.0955H26.2641L26.5215 20.6207ZM26.1691 8.95775H24.835V5.29025H26.0585L26.1691 8.95775Z",
    fill: "#BFCACC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2641 12.0956H24.835V8.95782H26.1691L26.2641 12.0956Z",
    fill: "#C83043"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0585 5.29028H24.835V2.15278H25.9635L26.0585 5.29028Z",
    fill: "#C83043"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99294 27.4854H2.31738L2.72635 13.9506L2.82146 10.8127L2.93198 7.14513L3.02708 4.0078H5.28386L5.37879 7.14513L5.48939 10.8127L5.58432 13.9506L5.99294 27.4854Z",
    fill: "#D2D9DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58428 13.9506H2.72632L2.82142 10.8127H5.48935L5.58428 13.9506Z",
    fill: "#E96666"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37869 7.14514H2.93188L3.02699 4.00781H5.28376L5.37869 7.14514Z",
    fill: "#E96666"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90419 24.9459H4.14282V13.9506H5.57229L5.90419 24.9459ZM5.47718 10.8128H4.14282V7.14517H5.36649L5.47718 10.8128Z",
    fill: "#BFCACC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57229 13.9506H4.14282V10.8127H5.47718L5.57229 13.9506Z",
    fill: "#C83043"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36649 7.14514H4.14282V4.00781H5.27156L5.36649 7.14514Z",
    fill: "#C83043"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0377 19.6865H4.89282V24.9459H22.0377V19.6865Z",
    fill: "#D2D9DB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0377 20.0725H4.89282V19.6865H22.0377V20.0725Z",
    fill: "#D0667A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3772 21.9084H6.05884V20.8646H15.3772V21.9084Z",
    fill: "#0E6563"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07259 21.9084H7.88501V20.8647H8.07259V21.9084Z",
    fill: "#547885"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89896 21.9084H9.71094V20.8647H9.89896V21.9084Z",
    fill: "#547885"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7249 21.9084H11.5371V20.8647H11.7249V21.9084Z",
    fill: "#547885"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5509 21.9084H13.363V20.8647H13.5509V21.9084Z",
    fill: "#547885"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3093 24.9459H31.8234V20.6208H24.3093V24.9459Z",
    fill: "#B3B8BF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3442 21.89H28.1448V21.4271H29.3442V21.89Z",
    fill: "#0E6563"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1635 21.89H29.9644V21.4271H31.1635V21.89Z",
    fill: "#0E6563"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3442 22.9459H28.1448V22.4829H29.3442V22.9459Z",
    fill: "#0E6563"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1635 22.9459H29.9644V22.4829H31.1635V22.9459Z",
    fill: "#0E6563"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8571 21.7176V24.946H0.493408V34.1182H25.5771V24.946V21.7176H16.8571Z",
    fill: "#C5C8CE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9286 23.4777H17.5505V22.9458H18.9286V23.4777Z",
    fill: "#0E6563"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8748 23.4777H19.4968V22.9458H20.8748V23.4777Z",
    fill: "#0E6563"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.821 23.4777H21.4431V22.9458H22.821V23.4777Z",
    fill: "#0E6563"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.767 23.4777H23.3892V22.9458H24.767V23.4777Z",
    fill: "#0E6563"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8572 22.1034H25.5772V21.7175H16.8572V22.1034Z",
    fill: "#D0667A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8572 25.3319H0.532959V24.946H16.8572V25.3319Z",
    fill: "#D0667A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5771 24.9459H29.8137V21.7175H25.5771V24.9459Z",
    fill: "#A0A5AC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7592 27.4854H1.44067V26.7137H10.7592V27.4854Z",
    fill: "#0E6563"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45462 27.4854H3.2666V26.7138H3.45462V27.4854Z",
    fill: "#547885"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28036 27.4854H5.09277V26.7138H5.28036V27.4854Z",
    fill: "#547885"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10696 27.4854H6.91895V26.7138H7.10696V27.4854Z",
    fill: "#547885"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93312 27.4854H8.74536V26.7138H8.93312V27.4854Z",
    fill: "#547885"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4253 27.4854H7.10693V26.7137H16.4253V27.4854Z",
    fill: "#0E6563"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1207 27.4854H8.93286V26.7138H9.1207V27.4854Z",
    fill: "#547885"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9469 27.4854H10.7593V26.7138H10.9469V27.4854Z",
    fill: "#547885"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7732 27.4854H12.5854V26.7138H12.7732V27.4854Z",
    fill: "#547885"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5992 27.4854H14.4114V26.7138H14.5992V27.4854Z",
    fill: "#547885"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21704 30.5259H12.7619V29.9688H5.21704V30.5259Z",
    fill: "#688D9E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72606 32.7643H6.47989V30.526H7.72606V32.7643ZM7.72011 29.9688H6.47183C6.41324 29.4552 6.03913 29.0361 5.54565 28.905V28.604L7.72011 29.9688Z",
    fill: "#AFB3BA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72616 30.2474H6.47998V30.1101C6.47998 30.0624 6.47727 30.0152 6.47192 29.9689H7.7202L7.73325 29.977C7.72861 30.0208 7.72616 30.0651 7.72616 30.1101V30.2474Z",
    fill: "#5D7F8E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47998 30.526H7.72617V30.5259H6.47998V30.526Z",
    fill: "#7D8E98"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47998 30.5259H7.72617V30.2474H6.47998V30.5259Z",
    fill: "#446773"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 29.1205H5.5453V28.6041H4.88867V29.1205Z",
    fill: "#4E6D78"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54527 28.9049C5.44062 28.8771 5.33054 28.8623 5.21704 28.8623V28.604H5.54527V28.9049Z",
    fill: "#4F7474"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48001 32.7643V30.1101C6.48001 29.4209 5.91437 28.8623 5.21702 28.8623C4.51932 28.8623 3.95386 29.4209 3.95386 30.1101V32.7643H6.48001Z",
    fill: "#5FAEAE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48003 32.7643H5.21704V28.8623C5.91439 28.8623 6.48003 29.4209 6.48003 30.1101V30.2474V30.5259V30.526V32.7643Z",
    fill: "#10888D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4987 32.7643H10.2524V30.526H11.4987V32.7643ZM11.492 29.9688H10.2443C10.1857 29.455 9.81137 29.0358 9.31763 28.9049V28.604L11.492 29.9688Z",
    fill: "#AFB3BA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4988 30.2474H10.2524V30.1101C10.2524 30.0624 10.2497 30.0152 10.2444 29.9689H11.492L11.5059 29.9775C11.5012 30.0211 11.4988 30.0653 11.4988 30.1101V30.2474Z",
    fill: "#5D7F8E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2524 30.526H11.4988V30.5259H10.2524V30.526Z",
    fill: "#7D8E98"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2524 30.5259H11.4988V30.2474H10.2524V30.5259Z",
    fill: "#446773"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66089 29.1205H9.31769V28.6041H8.66089V29.1205Z",
    fill: "#4E6D78"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31773 28.9049C9.21308 28.8771 9.103 28.8623 8.9895 28.8623V28.604H9.31773V28.9049Z",
    fill: "#4F7474"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2524 32.7643V30.1101C10.2524 29.4209 9.68676 28.8623 8.98941 28.8623C8.29171 28.8623 7.72607 29.4209 7.72607 30.1101V32.7643H10.2524Z",
    fill: "#5FAEAE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2525 32.7643H8.9895V28.8623C9.68685 28.8623 10.2525 29.4209 10.2525 30.1101V30.2474V30.5259V30.526V32.7643Z",
    fill: "#10888D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2877 34.1182H13.0352V32.7644H14.0246V30.1102C14.0246 29.5332 13.6284 29.0478 13.0901 28.905V28.6417L18.2877 32.1957V34.1182Z",
    fill: "#AFB3BA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4333 29.1205H13.0902V28.6041H12.4333V29.1205Z",
    fill: "#4E6D78"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0904 28.9049C12.9856 28.8771 12.8755 28.8623 12.762 28.8623V28.604H13.0904V28.9049Z",
    fill: "#4F7474"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0248 32.7643V30.1101C14.0248 29.4209 13.4593 28.8623 12.7618 28.8623C12.0642 28.8623 11.4988 29.4209 11.4988 30.1101V32.7643H14.0248Z",
    fill: "#5FAEAE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0249 32.7643H12.762V28.8623C13.4595 28.8623 14.0249 29.4209 14.0249 30.1101V32.7643Z",
    fill: "#10888D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14.935 34.1182H3.0564V32.7644H14.935V34.1182Z",
    fill: "#D9DCDF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M14.935 33.075H3.0564V32.7643H14.935V33.075Z",
    fill: "#EBEDEE"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.369 34.1182H19.5895C19.5835 32.0287 19.572 28.2724 19.5674 26.8679C19.7012 26.7191 19.7824 26.5231 19.7824 26.3084C19.7824 26.2706 19.7798 26.2334 19.775 26.1969L21.369 27.5073V34.1182Z",
    fill: "#AFB3BA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2916 26.8694C18.157 26.7203 18.0752 26.5237 18.0752 26.3083C18.0752 25.8427 18.4573 25.4651 18.9287 25.4651C19.3618 25.4651 19.7197 25.7839 19.775 26.1968L19.3645 25.8594C19.3469 25.8431 19.3283 25.8279 19.3088 25.8135C19.3012 25.8078 19.2935 25.8027 19.2853 25.7969C19.2701 25.7867 19.2546 25.7774 19.239 25.7689L19.2162 25.7567L19.2121 25.7547C19.2034 25.7505 19.1943 25.7465 19.1858 25.7428C19.1778 25.7392 19.1699 25.7358 19.1615 25.7329L19.1559 25.7307C19.1468 25.7269 19.1377 25.7241 19.1281 25.7209L19.1056 25.7139L19.0948 25.7111C19.0871 25.709 19.0794 25.7072 19.071 25.7054C19.0592 25.7026 19.0469 25.7002 19.0344 25.6982C19.0252 25.6966 19.0156 25.6953 19.006 25.6941C18.9852 25.6912 18.9641 25.6896 18.9422 25.6896L18.9287 25.6891C18.5769 25.6891 18.2916 25.971 18.2916 26.3189C18.2916 26.3189 18.2916 26.5223 18.2916 26.869C18.2916 26.8691 18.2916 26.8693 18.2916 26.8694Z",
    fill: "#A3ADB1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5676 26.8679C19.5676 26.8677 19.5676 26.8675 19.5676 26.8672C19.5668 26.5283 19.5663 26.3264 19.5663 26.3187C19.5663 26.3186 19.5663 26.3186 19.5663 26.3186C19.5663 26.3185 19.5663 26.3185 19.5663 26.3185C19.5663 26.297 19.5652 26.2758 19.5631 26.2547C19.5614 26.2373 19.5588 26.2202 19.5556 26.2035C19.5471 26.1576 19.5333 26.1129 19.5148 26.0711C19.5116 26.0626 19.5073 26.0541 19.5035 26.046C19.499 26.0367 19.4944 26.0276 19.4894 26.0187C19.4796 26.0008 19.4689 25.9833 19.4574 25.9665C19.452 25.9586 19.4458 25.9501 19.4398 25.9419L19.4206 25.9184C19.4034 25.8975 19.3847 25.8779 19.3647 25.8595L19.7752 26.1969C19.78 26.2334 19.7826 26.2706 19.7826 26.3084C19.7826 26.5231 19.7014 26.719 19.5676 26.8679Z",
    fill: "#919CA0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5893 34.1182H18.2926C18.2919 32.0291 18.2915 28.2744 18.2915 26.8692C18.2915 26.5225 18.2915 26.319 18.2915 26.319C18.2915 25.9711 18.5768 25.6892 18.9286 25.6892L18.9421 25.6897C18.964 25.6897 18.9851 25.6913 19.0059 25.6943C19.0155 25.6954 19.0251 25.6967 19.0343 25.6983C19.0468 25.7003 19.0591 25.7027 19.0709 25.7056C19.0793 25.7073 19.087 25.7092 19.0947 25.7113L19.1055 25.7141L19.128 25.7211C19.1376 25.7242 19.1467 25.727 19.1558 25.7308L19.1614 25.733C19.1698 25.736 19.1777 25.7393 19.1857 25.743C19.1942 25.7466 19.2033 25.7507 19.212 25.7548L19.2161 25.7568L19.2389 25.7691C19.2545 25.7776 19.27 25.7868 19.2852 25.797C19.2934 25.8028 19.3011 25.8079 19.3087 25.8136C19.3502 25.8441 19.3877 25.879 19.4203 25.9185L19.4395 25.9419C19.4455 25.9502 19.4517 25.9587 19.4571 25.9665C19.4686 25.9834 19.4794 26.0008 19.4891 26.0187C19.4941 26.0277 19.4987 26.0367 19.5032 26.046C19.507 26.0541 19.5113 26.0626 19.5146 26.0711C19.533 26.113 19.5468 26.1576 19.5553 26.2035C19.5585 26.2202 19.5612 26.2373 19.5628 26.2547C19.5649 26.2759 19.5661 26.297 19.5661 26.3185C19.5661 26.3185 19.5664 26.5216 19.5673 26.8672C19.5719 28.271 19.5834 32.0284 19.5893 34.1182Z",
    fill: "#EFEFF2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5894 34.1182H18.9421V25.6897C18.9637 25.6902 18.9851 25.6916 19.006 25.6943C19.0155 25.6954 19.0252 25.6967 19.0344 25.6983C19.0469 25.7003 19.0591 25.7027 19.071 25.7056C19.0794 25.7073 19.0871 25.7092 19.0948 25.7113L19.1056 25.7141L19.1281 25.7211C19.1377 25.7242 19.1467 25.727 19.1558 25.7308L19.1614 25.733C19.1698 25.736 19.1777 25.7393 19.1858 25.743C19.1943 25.7466 19.2034 25.7507 19.212 25.7548L19.2162 25.7568L19.2389 25.7691C19.2545 25.7776 19.27 25.7868 19.2853 25.797C19.2935 25.8028 19.3012 25.8079 19.3087 25.8136C19.3502 25.8441 19.3877 25.879 19.4204 25.9185L19.4396 25.9419C19.4455 25.9502 19.4517 25.9587 19.4572 25.9665C19.4686 25.9834 19.4794 26.0008 19.4891 26.0187C19.4941 26.0277 19.4988 26.0367 19.5032 26.046C19.5071 26.0541 19.5114 26.0626 19.5146 26.0711C19.5331 26.113 19.5468 26.1576 19.5553 26.2035C19.5586 26.2206 19.5612 26.2376 19.5629 26.2547C19.565 26.2759 19.5661 26.297 19.5661 26.3185C19.5661 26.3185 19.5661 26.3185 19.5661 26.3186C19.5661 26.3186 19.5661 26.3186 19.5661 26.3187C19.5661 26.3265 19.5665 26.5283 19.5673 26.8672C19.572 28.271 19.5834 32.0284 19.5894 34.1182Z",
    fill: "#E1E2E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1056 34.1182H17.7795V33.3619H20.1056V34.1182Z",
    fill: "#CED1D6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3689 34.1182H33.2392V24.946H21.3689V34.1182Z",
    fill: "#D2D9DB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2392 25.3319H21.3689V24.946H33.2392V25.3319Z",
    fill: "#D0667A"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5806 34.1224H30.0684V34.1181H29.5806V34.1224Z",
    fill: "#91979E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0683 34.1182H29.5805V29.3034C29.5805 29.0077 29.465 28.7386 29.2759 28.5378V28.5369L30.081 29.1349C30.0727 29.1899 30.0683 29.2462 30.0683 29.3034V34.1182Z",
    fill: "#BAC3C6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5806 29.3033C29.5806 28.6824 29.0711 28.1788 28.4423 28.1788C27.8137 28.1788 27.3042 28.6824 27.3042 29.3033V34.1224H29.5806V29.3033Z",
    fill: "#E96666"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5804 34.1224H28.4421V28.1788C29.0709 28.1788 29.5804 28.6824 29.5804 29.3033V34.1181V34.1224Z",
    fill: "#B24B57"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3447 34.1224H33.2165V34.1181H32.3447V34.1224Z",
    fill: "#91979E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2164 34.1182H32.3446V29.3035C32.3446 29.0449 32.2562 28.8067 32.1077 28.6167L33.2164 29.5769V34.1182Z",
    fill: "#BAC3C6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3447 29.3033C32.3447 28.6824 31.8351 28.1788 31.2066 28.1788C30.5779 28.1788 30.0684 28.6824 30.0684 29.3033V34.1224H32.3447V29.3033Z",
    fill: "#E96666"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3447 34.1224H31.2065V28.1788C31.835 28.1788 32.3447 28.6824 32.3447 29.3033V34.1181V34.1224Z",
    fill: "#B24B57"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 30.3312H22.821V28.5007H24.3094V30.3312Z",
    fill: "#AFB2B9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 28.8542H22.821V28.681H24.3094V28.8542Z",
    fill: "#969CA3"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 29.1874H22.821V29.0142H24.3094V29.1874Z",
    fill: "#969CA3"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 29.5203H22.821V29.347H24.3094V29.5203Z",
    fill: "#969CA3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 29.8531H22.821V29.68H24.3094V29.8531Z",
    fill: "#969CA3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3094 30.1862H22.821V30.0128H24.3094V30.1862Z",
    fill: "#969CA3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6497 27.0339H22.272V26.5022H23.6497V27.0339Z",
    fill: "#0E6563"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4082 27.0339H24.0305V26.5022H25.4082V27.0339Z",
    fill: "#0E6563"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.c8714ec8631b075d307d0e7cd21d032e.svg";
export { ForwardRef as ReactComponent };